/**
 * * Booking search transport page [find transport page]
 * * using fetchProposalsById method to get proposals[0].transports (inbound & outbound)
 */
import React, { Fragment } from 'react';
import { t } from 'Src/i18n';
import { useDispatch } from 'react-redux';
import { OverlaidActionProvider } from 'Components/widgets/overlaid-action-provider/OverlaidActionProvider';
import { isRecommendedTransport } from 'Utils/proposal/proposalUtils';
import { BeTransportDetails } from 'Components/widgets/be-transport-details/BeTransportDetails';
import { hasOnlyPlanes } from 'Components/widgets/transport-details/transportUtils';
import { putTransportAndDispatchProposals } from 'Store/booking/proposals/proposals.action';
import { openToast } from 'Store/toast/toast.actions';
import { getAllProposalsIdWithAlternative } from 'Views/booking/BookingEngine.utils';
import { useAppContext } from 'Context/ReactAppContext';
import { MoreTransports } from './more-transports/MoreTransports';
import { TransferBulletPoints } from './TransferBulletPoints';
export const PRODUCT_TYPE = {
  CRUISE: 'CRUISE',
};
export const TransportsSection = ({
  i18n,
  resort,
  selectedProposal,
  onMoreTransportsClick,
  closeLayer,
  shouldShowLayer,
}: any) => {
  const appContext = useAppContext();
  const dispatch = useDispatch();
  const { transports } = selectedProposal || {};
  const isTransportRecommended = isRecommendedTransport(transports, selectedProposal.id);

  const handleAddTransport = (transportId: string) => {
    const transportI18n = i18n.booking.transport;
    Promise.resolve(closeLayer(true, selectedProposal.id)).then(() => {
      if (transportId === selectedProposal.id) {
        // no need to call the addTransportMutation because the recommended flight is selected by default
        setTimeout(() => dispatch(openToast(transportI18n.newTransportSelection)), 1000);
      } else {
        dispatch(
          putTransportAndDispatchProposals(
            transportId,
            getAllProposalsIdWithAlternative(selectedProposal),
            resort.isJoyview,
            resort.isUrbanOasis,
            appContext,
            transportI18n.additionalTransports.loaderLabelUpdate,
            transportI18n.newTransportSelection,
          ),
        );
      }
    });
  };

  const isPlane = hasOnlyPlanes(transports?.inbound?.travelSections);
  return (
    <Fragment>
      <OverlaidActionProvider
        label={t('booking.transport.headlineCTA')}
        button={{
          label: t(
            isPlane
              ? 'booking.transport.additionalTransports.otherProposals'
              : 'booking.otherTransport',
          ),
          onClick: onMoreTransportsClick,
        }}
      >
        <div className="TransportsView-context mt-20">
          <BeTransportDetails
            transport={selectedProposal?.transports}
            isTransportRecommended={isTransportRecommended}
          />
          <div className="mt-20">
            <TransferBulletPoints
              title="common.transport.transfer.information"
              bulletPoints={[
                'common.transport.transfer.cancellationReinsurance',
                'common.transport.transfer.tripTogether',
                'common.transport.transfer.arrivalPickup',
                'common.transport.transfer.luggage',
              ]}
            />
          </div>
        </div>
      </OverlaidActionProvider>

      {shouldShowLayer && (
        <MoreTransports
          proposal={selectedProposal}
          onClose={closeLayer}
          setSelectedTransport={handleAddTransport}
        />
      )}
    </Fragment>
  );
};
